import { Divider } from '@mui/material'
import EventMainCard from '../../../components/Cards/EventMainCard'
import { H4 } from '../../../themes/typography'

function UserLikesEvents() {
    return (
        <div className='user-likes-events-container'>

            <Divider
                sx={{
                    borderColor: 'var(--divider-color)',
                    alignSelf: 'stretch'
                }}
            />

            <div className='user-likes-events-content'>
                <H4>
                    You may also like this events
                </H4>
                <div className='user-likes-events-list'>
                    {Array.from({ length: 4 }, (_, index) => (
                        <EventMainCard key={index} />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default UserLikesEvents